import React from "react";

const SvgHighConfidence = (props) => (
  <svg width={67} height={66} {...props}>
    <g fill="none" fillRule="evenodd">
      <ellipse
        stroke="#D9D9D9"
        strokeWidth={3.78}
        cx={33.5}
        cy={32.726}
        rx={31.61}
        ry={30.836}
      />
      <ellipse
        stroke="#0EBEFF"
        strokeWidth={4}
        cx={33.5}
        cy={33}
        rx={31.5}
        ry={31}
      />
    </g>
  </svg>
);

export default SvgHighConfidence;
